<dt-modal-content (closeClick)="close()">
  <ng-template #title i18n>Schritte überspringen</ng-template>
  <ng-template #content>
    <p i18n
      >Du hast noch nicht alle Teilschritte bis zu diesem Schritt abgeschlossen. Wenn Du den Schritt trotzdem aufrufst, werden nicht
      bearbeitete Teilschritte übersprungen. Wir empfehlen in jedem Falle alle Teilschritte zu durchlaufen, um ein optimales Ergebnis zu
      erzielen. Nachträglich können alle Teilschritte weiterhin betreten und bearbeitet werden.</p
    >
    <p i18n>Möchtest Du die betreffenden Teilschritte überspringen?</p>
    <mat-checkbox [(ngModel)]="doNotShowAgain" i18n>Nicht erneut anzeigen</mat-checkbox>
  </ng-template>
  <ng-template #footer>
    <button mat-raised-button color="accent" (click)="close('navigate-to-latest')" i18n>Zum letzten bearbeiteten Schritt</button>
    <button mat-raised-button color="accent" (click)="close('confirm')" i18n>Ja, überspringen</button>
    <button mat-raised-button color="accent-less" (click)="close()" i18n>Nein, abbrechen</button>
  </ng-template>
</dt-modal-content>
